export default __webpack_public_path__ + "assets/assam_before.jpg";